'use client'

import { useQuery } from '@tanstack/react-query'

import { fetchLevelProfileSnapshot } from '@/service/analytics/level-profiles.api'
import type { LevelProfileAnalyticsType } from '@/service/analytics/level-profiles.types'
import type { GetAnalyticSnapshotRequest } from '@/types/generated/public_api'

export const levelProfileKeys = {
  all: ['levelProfile'] as const,
  snapshot: (params: GetAnalyticSnapshotRequest) =>
    [
      ...levelProfileKeys.all,
      'snapshot',
      params.exchange,
      params.symbol,
      params.analyticsType,
    ] as const,
}

export function useLevelProfileSnapshot<T extends LevelProfileAnalyticsType>(
  params: GetAnalyticSnapshotRequest & { analyticsType: T },
  enabled = true
) {
  return useQuery({
    queryKey: levelProfileKeys.snapshot(params),
    queryFn: ({ signal }) => fetchLevelProfileSnapshot(params, signal),
    enabled: enabled && Boolean(params.symbol) && Boolean(params.exchange),
    staleTime: 10 * 1000,
    // A 404 ("not yet published") is an expected, stable terminal state — retrying just spams
    // the endpoint waiting for a publish that may not happen for a while (up to the publisher's heartbeat).
    retry: false,
  })
}
